import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { Action } from '@reduxjs/toolkit';
import { RootState } from '@share/utils';
import { getawaysActions } from '@store/slices';


import { ConciergeBooking } from '../concierge-booking';
import { ConciergeContact } from '../concierge-contact';
import { ConciergeHeading } from '../concierge-heading';
import { ConciergeOffices } from '../concierge-offices';
import { ConciergeWelcome } from '../concierge-welcome';

interface IMapDispatchToProps {
  setGetawaysListPage: (isGetawayListPage?: boolean) => void;
}
interface IProps extends IMapDispatchToProps {}

class ConciergeWrapperComponent extends Component<IProps, null> {
  componentDidMount() {
    this.props.setGetawaysListPage(true);
  }

  render(): React.ReactNode {
    return (
      <>
        <ConciergeHeading />
        <ConciergeWelcome />
        <ConciergeOffices />
        <ConciergeContact />
        <ConciergeBooking />
      </>
    );
  }
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, undefined, Action>,
): IMapDispatchToProps => ({
  setGetawaysListPage: (isGetawayListPage) => {
    dispatch(getawaysActions.setGetawaysListPage(isGetawayListPage));
  },
});

export const Concierge = connect(null, mapDispatchToProps)(ConciergeWrapperComponent);
